import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/button';
import {getIntroCardImageSrc} from 'common/utils/statics-util';
import './index.scss';

export default class IntroCard extends React.Component {
  static propTypes = {
    buttonText: PropTypes.string,
    children: PropTypes.any,
    onButtonClick: PropTypes.func,
    style: PropTypes.object,
    svgName: PropTypes.string,
  };

  static propDefaults = {
    buttonText: null,
    style: {},
    svgName: null,
  };

  render() {
    return (
      <div className={'IntroCard'} style={this.props.style}>
        {!this.props.svgName ? null : (
          <div
            style={{
              backgroundImage: `url(${getIntroCardImageSrc(
                this.props.svgName,
              )}.svg)`,
            }}
          />
        )}
        {this.props.children}
        {!this.props.buttonText ? null : (
          <Button onClick={this.props.onButtonClick} type={'green'}>
            {this.props.buttonText}
          </Button>
        )}
      </div>
    );
  }
}
